import { useState } from "react";

const ALL_MUSCLE_GROUPS = ["Chest", "Back", "Legs", "Shoulders", "Arms", "Core"];

export default function WorkoutGenerationForm({
  recentMuscles,
  suggestedFocus,
  onGenerate,
  onCancel,
}) {
  const [genTime, setGenTime] = useState(30);
  const [genEnergy, setGenEnergy] = useState(3);
  const [genFocus, setGenFocus] = useState("auto");
  const [genNote, setGenNote] = useState("");

  const handleGenerate = () => {
    const focus = genFocus === "auto" ? suggestedFocus : genFocus;
    onGenerate({
      available_time: genTime,
      energy_level: genEnergy,
      muscle_focus: focus,
      recent_muscles: [...recentMuscles],
      limitations_today: genNote || undefined,
    });
  };

  return (
    <div style={{ animation: "fadeIn 0.2s ease" }}>
      <div className="mb-16">
        <div className="label-sm mb-8">How much time?</div>
        <div className="flex-center-gap-6">
          {[20, 30, 45, 60].map((t) => (
            <button
              key={t}
              className={`selector-chip flex-1${genTime === t ? " selector-chip--active" : ""}`}
              aria-pressed={genTime === t}
              onClick={() => setGenTime(t)}
            >
              {t} min
            </button>
          ))}
        </div>
      </div>

      <div className="mb-16">
        <div className="label-sm mb-8">Energy level</div>
        <div className="flex-center-gap-8">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              className={`energy-dot${n <= genEnergy ? " energy-dot--active" : ""}`}
              aria-pressed={n <= genEnergy}
              aria-label={`Energy level ${n}`}
              onClick={() => setGenEnergy(n)}
            >
              <span className="energy-dot-label">{n}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="mb-16">
        <div className="label-sm mb-8">Focus</div>
        <div className="flex-wrap-gap-6" role="radiogroup" aria-label="Muscle focus">
          <button
            className={`focus-chip${genFocus === "auto" ? " focus-chip--active" : ""}`}
            aria-pressed={genFocus === "auto"}
            onClick={() => setGenFocus("auto")}
          >
            Coach&apos;s pick
          </button>
          {ALL_MUSCLE_GROUPS.map((mg) => {
            const isRecent = recentMuscles.has(mg);
            const isSelected = genFocus === mg;
            return (
              <button
                key={mg}
                className={`focus-chip${isSelected ? " focus-chip--active" : ""}`}
                aria-pressed={isSelected}
                onClick={() => setGenFocus(mg)}
                style={{
                  ...(isRecent && !isSelected ? { opacity: 0.6, color: "var(--text3)" } : {}),
                }}
              >
                {mg}
              </button>
            );
          })}
        </div>
        {recentMuscles.size > 0 && (
          <div className="mono text-11-muted mt-6">
            {[...recentMuscles].join(", ")} trained in last 2 days
          </div>
        )}
      </div>

      <div className="mb-16">
        <div className="label-sm mb-8">Anything to note?</div>
        <input
          placeholder="Shoulder is sore, want to focus on legs..."
          value={genNote}
          onChange={(e) => setGenNote(e.target.value)}
          style={{ width: "100%", boxSizing: "border-box", fontSize: 13 }}
        />
      </div>

      <div className="flex-center-gap-8">
        <button className="btn btn-primary flex-1 btn-h44" onClick={handleGenerate}>
          Generate
        </button>
        <button
          className="btn btn-secondary btn-h44"
          style={{ padding: "0 16px" }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
